export const spinnerGenerator = <T extends unknown[]>(items: T) => {
  const spinLine = [];

  for (let i = 0; i < 10; i++) {
    const idx = Math.floor(Math.random() * items.length);

    spinLine.push(items[idx]);
  }

  return spinLine.concat(spinLine).concat(spinLine) as T;
};
